import React from "react";
import { NavLink } from "react-router-dom";

export default ({ className, hide }) => (
  <div className={`${className} ${hide ? "is-hidden" : ""} `}>
    <section className="section">
      <aside className="menu">
        <p className="menu-label">Company</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/companies" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink to="/companies/create" activeClassName="is-active" exact>
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">User</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/users" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink to="/users/create" activeClassName="is-active" exact>
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Role</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/roles" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink to="/roles/create" activeClassName="is-active" exact>
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Permission</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/permissions" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink to="/permissions/create" activeClassName="is-active" exact>
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Payment Gateway</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/available-gateways" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/available-gateways/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Feature Action</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/highlight-actions" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/highlight-actions/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Company Profile Type</p>
        <ul className="menu-list">
          <li>
            <NavLink
              to="/company-profile-types"
              activeClassName="is-active"
              exact
            >
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/company-profile-types/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Promotion Type</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/promotion-types" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/promotion-types/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Product Status</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/product-status" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/product-status/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Order Status</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/order-status" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/order-status/create"
              activeClassName="is-active"
              exact
            >
              Create New
            </NavLink>
          </li>
        </ul>

        <p className="menu-label">Rate Limit</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/rate-limits" activeClassName="is-active" exact>
              View All
            </NavLink>
          </li>
          <li>
            <NavLink to="/rate-limits/create" activeClassName="is-active" exact>
              Create New
            </NavLink>
          </li>
        </ul>
      </aside>
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Sidebar.js